import React from 'react';

type Props = {
  amount: number;
  currency?: string;
  minimumFractionDigits?: number;
  maximumFractionDigits?: number;
  showCurrency?: boolean;
};

const Currency = ({
  currency = 'USD',
  amount,
  minimumFractionDigits = 0,
  maximumFractionDigits = 0,
  showCurrency = false,
}: Props) => {
  return (
    <>
      <span>
        {new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency,
          minimumFractionDigits,
          maximumFractionDigits,
        }).format(Number(amount))}
      </span>
      {showCurrency && <span>{` ${currency}`}</span>}
    </>
  );
};

export default Currency;
